import { defineStore } from 'pinia'
import firebaseFuncs from '@/utils/firebase'

let { getData, getSermonYears, getSermons } = firebaseFuncs

export const useDataStore = defineStore('useData', {
  state: () => ({
    sermons: [],
    latestSermons: [],
    devotionals: null,
    events: null,
    sermonYears: [],
    sermonsLastDoc: null,
    hasMoreSermons: true,
    initialDataLoad: false
  }),

  actions: {
    async getAllData() {
      this.events = await getData('events')
      await this.getLatestSermons({ limit: 20 })
      this.devotionals = await getData('devotionals')

      this.initialDataLoad = true
    },

    async getLatestSermons() {
      this.latestSermons = await getSermons({ year: null, query: null, pagination: { limit: 20 } })
    },

    async getSermons({ year, query, pagination } = {}) {

      try {
        const data = await getSermons({ year, query, pagination })
        if (!Array.isArray(data)) {
          console.error('getSermons returned non-array:', data)
          return
        }
        if (pagination && pagination.startAfter) {
          // Append to existing sermons
          this.sermons = [...this.sermons, ...data]
        } else {
          // Initial load
          this.sermons = data
        }
        // Update last doc and hasMore
        if (data.length > 0) {
          this.sermonsLastDoc = data[data.length - 1].id
          this.hasMoreSermons = data.length === (pagination ? pagination.limit : 20)
        } else {
          this.hasMoreSermons = false
        }
        return this.sermons
      } catch (error) {
      }
    },

    async loadMoreSermons(year) {
      if (!this.sermonsLastDoc || !this.hasMoreSermons) return
      await this.getSermons({ year: year ? parseInt(year) : null, query: null, pagination: { limit: 20, startAfter: this.sermonsLastDoc } })
    },

    async getDevotionals() {
      this.devotionals = await getData('devotionals')
    },

    async getEvents() {
      this.events = await getData('events')
    },

    async getSermonYears() {
      this.sermonYears = await getSermonYears()
    }
  }
})
